<template>
  <path
    :d="shape.d"
    fill="transparent"
    :stroke="shape.isFilled ? 'black' : 'inherit'"
    :stroke-width="shape.strokeWidth + hightlightOffset"
    stroke-linejoin="round"
    :transform="shape.svgTransform"
  />
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    shape: Object,
    hightlightOffset: {
      type: Number,
      default: 0
    }
  }
});
</script>
